var React = require('react');

function Learn (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"3","y1":"3","x2":"3","y2":"21","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"7","y1":"3","x2":"7","y2":"21","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M11 20V3.60154C11 2.86217 11.7747 2.37847 12.439 2.70304L20.439 6.61162C20.7823 6.77934 21 7.12803 21 7.51011V20C21 20.5523 20.5523 21 20 21H12C11.4477 21 11 20.5523 11 20Z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":2})]);
}

Learn.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Learn;

Learn.default = Learn;
